import {formatInTimeZone, utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";
import {setMilliseconds} from "date-fns";

export * from 'date-fns';
export {getTimezoneOffset, formatInTimeZone} from 'date-fns-tz'

const timeZone = {
  value: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

const adjustToTimeZone = (date: Date | number = new Date()): Date => {
  return setMilliseconds(zonedTimeToUtc(date, timeZone.value), 0);
};

const adjustToTimeZoneSafely = (
  date: Date | number | undefined
): Date | undefined => {
  return date
    ? setMilliseconds(zonedTimeToUtc(date, timeZone.value), 0)
    : undefined;
};

const adjustFromTimeZone = (date: Date | number = new Date()): Date => {
  return setMilliseconds(utcToZonedTime(date, timeZone.value), 0);
};

const adjustFromTimeZoneSafely = (
  date: Date | number | undefined
): Date | undefined => {
  return date
    ? setMilliseconds(utcToZonedTime(date, timeZone.value), 0)
    : undefined;
};

const getFormattedTimeZone = (timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone, when = new Date()): string => {
  const formatShort = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short'
  })
  const partsShort = formatShort.formatToParts(when)
  const abbr = partsShort.find(p => p.type === 'timeZoneName')?.value ?? ''

  const formatOffset = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'shortOffset'
  })
  const partsOff = formatOffset.formatToParts(when)
  const raw = partsOff.find(p => p.type === 'timeZoneName')?.value || ''
  const offset = raw.replace('GMT', '')

  return `${abbr} ${offset}`
}

export {
  timeZone,
  adjustToTimeZone,
  adjustToTimeZoneSafely,
  adjustFromTimeZone,
  adjustFromTimeZoneSafely,
  getFormattedTimeZone,
};
